// extracted by mini-css-extract-plugin
export default {"loader":"loader___d17bbe9554e59f97","surveyHeader":"surveyHeader___b87251998f8ba3b7"};